import React, { useEffect, useState } from "react";
import photo from "../../../assets/images/user4.jpg";
import { IMemberListData } from "../../../exports/interfaces";
import TableFilter from "./TableFilter";
import useMobile from "../../../hooks/useMobile";
import useTab from "../../../hooks/useTab";
import { useNavigate } from "react-router-dom";
import DeletePopUp from "../../DeletePopUp";
import { useLoader } from "../../../context/LoaderContext";
import axios from "axios";
import { failed, success } from "../../../hooks/useToast";
import { headers } from "../../../exports/exports";
import { fetchMemberLists } from "../../../api/MemberApi";
import DynamicToolTip from "../../DynamicToolTip";
import { getMembershipStatusColor } from "../../../exports/functions";

const AdminMemberTable = (props: { listMemberData: IMemberListData[] }) => {
  const { setLoading } = useLoader();
  const [deleteId, setDeleteId] = useState<number>();
  const [deleteSisId, setDeleteSisId] = useState<number>();
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const mobile = useMobile();
  const tab = useTab();
  const [filteredData, setFilteredData] = useState<IMemberListData[]>(
    props.listMemberData
  );
  const navigate = useNavigate();
  const token = localStorage.getItem("frcsit:access-token");
  const sisheaders = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    setFilteredData(props.listMemberData);
  }, [props.listMemberData]);
  const rowsPerPage = 15;

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handlePageClick = (page: number) => {
    setCurrentPage(page);
  };

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const currentData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handleDelete = async () => {
    setLoading(true);
    try {
      const userRes = await axios.delete(
        `${process.env.REACT_APP_IDENTITY_SERVER_URL}api/admin/users/${deleteSisId}`,
        {
          headers: sisheaders,
        }
      );
      if (userRes?.status === 200 || userRes?.status === 201) {
        axios
          .delete(
            `${process.env.REACT_APP_strapiUrl}/api/frcsit-users/${deleteId}`,
            {
              headers: headers,
            }
          )
          .then(() => {
            fetchMemberLists()
              .then((listMemberData) => {
                setFilteredData(listMemberData);
                setLoading(false);
                success();
              })
              .catch(() => {
                setLoading(false);
                failed();
              });
          })
          .catch(() => failed());
      } else {
        failed();
      }
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      <section
        className="quality-work"
        style={{
          marginLeft: !mobile && !tab ? "240px" : "unset",
          padding: "0px 0px 20px 0px",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="quality-work__tab-box tabs-box">
                <div
                  className="donation-details__presentation custom-feature-two__single"
                  style={{
                    padding: "0px",
                    backgroundColor: "transparent",
                    // overflow: "unset",
                    height: "auto",
                    flexDirection: "column",
                    gap: "unset",
                    overflow: "hidden",
                  }}
                >
                  <TableFilter
                    listMemberData={props.listMemberData}
                    setFilteredData={setFilteredData}
                    setCurrentPage={setCurrentPage}
                  />
                  <div style={{ width: "100%", overflow: "auto" }}>
                    <table
                      className="table cart-table custom-cart-table custom-cart-cell"
                      style={{ marginBottom: "unset" }}
                    >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Profile picture</th>
                          <th>Member Name & Specialization</th>
                          <th>Designation</th>
                          <th>Location</th>
                          <th>Email</th>
                          <th>Phone No.</th>
                          <th>Membership</th>
                          <th>Membership Expiry</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentData.length === 0 ? (
                          <tr>
                            <td
                              colSpan={10}
                              style={{ textAlign: "center", padding: "20px" }}
                            >
                              -- No Data Found --
                            </td>
                          </tr>
                        ) : (
                          currentData.map((data, index) => {
                            const { color } = getMembershipStatusColor(
                              data?.attributes?.Status
                            );
                            return (
                              <tr
                                key={index}
                                style={{
                                  backgroundColor:
                                    index % 2 !== 0 ? "#f2f0ec" : "unset",
                                }}
                              >
                                <td>
                                  {(currentPage - 1) * rowsPerPage + index + 1}
                                </td>
                                <td>
                                  <div className="product-box">
                                    <div
                                      className="img-box"
                                      // style={{ width: "80px" }}
                                    >
                                      {data?.attributes?.Profile_Picture
                                        ?.data !== null &&
                                      data?.attributes?.Profile_Picture
                                        ?.data !== undefined ? (
                                        <img
                                          src={`${process.env.REACT_APP_strapiUrl}${data?.attributes?.Profile_Picture?.data?.attributes?.url}`}
                                          alt="member"
                                          style={{
                                            width: "80px",
                                            height: "80px",
                                            objectFit: "cover",
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={photo}
                                          alt="member"
                                          style={{
                                            width: "80px",
                                            height: "80px",
                                            objectFit: "cover",
                                          }}
                                        />
                                      )}
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  {data?.attributes?.First_Name},{" "}
                                  {data?.attributes?.Qualifications}
                                </td>
                                <td>{data?.attributes?.Designation}</td>
                                <td>{data?.attributes?.Country}</td>
                                <td>{data?.attributes?.Email}</td>
                                <td>{data?.attributes?.Mobile_Number}</td>
                                <td>{data?.attributes?.Type_Of_Membership}</td>
                                <td>{data?.attributes?.Membership_Expiry ?? "-"}</td>
                                <td>
                                  <div
                                    className="statu-chip"
                                    style={{
                                      color: color,
                                    }}
                                  >
                                    {data?.attributes?.Status}
                                  </div>
                                  <div className="custom-table-action">
                                    <DynamicToolTip title="Edit">
                                      <span
                                        className="icon-pencil custom-edit"
                                        onClick={() =>
                                          navigate("/admin/members/edit", {
                                            state: { memberData: data },
                                          })
                                        }
                                      ></span>
                                    </DynamicToolTip>
                                    <DynamicToolTip title="Delete">
                                      <span
                                        className="icon-bin custom-delete"
                                        onClick={() => {
                                          setDeleteId(data?.id);
                                          setDeleteSisId(
                                            Number(data?.attributes?.sis_id)
                                          );
                                          setOpen(true);
                                        }}
                                      ></span>
                                    </DynamicToolTip>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {currentData.length !== 0 && (
              <div className="custom-pagination">
                <button
                  className="page-btn"
                  onClick={handlePrev}
                  disabled={currentPage === 1}
                >
                  ‹
                </button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                  (page) => (
                    <button
                      key={page}
                      className={`page-btn ${
                        currentPage === page ? "active" : ""
                      }`}
                      onClick={() => handlePageClick(page)}
                    >
                      {page}
                    </button>
                  )
                )}
                <button
                  className="page-btn"
                  onClick={handleNext}
                  disabled={currentPage === totalPages}
                >
                  ›
                </button>
              </div>
            )}
          </div>
        </div>
      </section>
      <DeletePopUp open={open} setOpen={setOpen} onDelete={handleDelete} />
    </>
  );
};

export default AdminMemberTable;
